import React,{useState,useEffect} from 'react';
import CustomModal from './CustomModal';
import { useTranslation } from 'react-i18next';
import constants from '../../common/constants';

const Landing = (props) => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const hostnames = ['iq', 'ro', 'ae', 'zkw']
    const has_sign_button = hostnames.includes(props.hostname);
    const operator = localStorage.getItem('currentOperator');
    const operatorDemos = ["DEMO","OOREDOO_ALGERIA"];
    const isOperator = operatorDemos.includes(operator);
    
    useEffect(() => {
        // Function to handle window resize event
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth <= 426);
        };
    
        // Add event listener for window resize
        window.addEventListener('resize', handleResize);
    
        // Call handleResize once on component mount to set initial state
        handleResize();
    
        // Cleanup function to remove event listener
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []); // Empty dependency array to run effect only once on mount

      const signout = () => { 
        localStorage.clear();
        props.setUserId('');
      };
      
      const handleShowModal = () => {
        if(isOperator){
          setShowModal(true);
          document.body.classList.add('no-scroll');
        }
        if(constants.Operators[operator].Sub_link){
          window.location.href = constants.Operators[operator].Sub_link
        }  
      };
  
      const handleCloseModal = () => {
        setShowModal(false);
        document.body.classList.remove('no-scroll'); // Enable scrolling
      };
    console.log(props.hostname)
    return (
     <div id="home" className='container'>
        <CustomModal user_id={props.user_id} setUserId={props.setUserId} showModal={showModal} handleClose={handleCloseModal}/>
        <div className='container text-light text-center home-text-centered'>
            <div className="bordeau-medium" style={{fontSize:"2.5em"}}>{t('landing.title')}</div>
            <p className={`pt-4  ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{fontSize:"1.5em"}}>
             {t('landing.description')}
            </p>
            { !has_sign_button && (
              <>
              {props.user_id ? (
                  <>
                    <a href='/'><button type="button" className={`btn sign-up-button ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} onClick={signout}>{t('nav.sign_out')}</button></a>
                  </>
                  ):(
                  <>
                    <button type="button" className={`btn sign-up-button  ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} onClick={handleShowModal}>{t('nav.sign_in')}</button>
                  </>
              )}
              
              </>
            )}

        </div>
        <div className='sport-images' style={{position: 'absolute', top: "10%", left: 0, zIndex: 1}}> 
            {isSmallScreen ? (
                <img src="../assets/images/group-images-2.png" className='w-100' />
            ) : (
                <img src="../assets/images/group-images.png" className='w-100' />
            )}
        </div>
     </div>
    );
  };
  
  export default Landing;